function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    if(event.target.closest('.header__inline-menu')) {
      window.location.href = event.target.getAttribute('data-url');
    } else {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    }
  });

  if(summary.closest('.header__inline-menu')) {
    summary.addEventListener('mouseenter',(event) => {
      event.target.setAttribute('aria-expanded', true);
      event.target.closest('details').setAttribute('open',true);
    });
    summary.parentNode.addEventListener('mouseleave',(event) => {
      event.target.querySelector('summary').setAttribute('aria-expanded', false);
      event.target.removeAttribute('open');
    });
  }

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});


const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    const max = parseFloat(this.getAttribute('data-max'));
    const error = this.parentNode.parentNode.querySelector('.quantity-input__error');

    if(event.target.name === 'plus' && previousValue >= max && error) {
      error.removeAttribute('hidden');
      return;
    }

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.money_format="${{amount}}",Shopify.formatMoney=function(a,o){"string"==typeof a&&(a=a.replace(".",""));var e="",t=/\{\{\s*(\w+)\s*\}\}/,o=o||this.money_format;function r(a,o){return void 0===a?o:a}function n(a,o,e,t){if(o=r(o,2),e=r(e,","),t=r(t,"."),isNaN(a)||null==a)return 0;a=(a=(a/100).toFixed(o)).split(".");return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+e)+(a[1]?t+a[1]:"")}switch(o.match(t)[1]){case"amount":e=n(a,2);break;case"amount_no_decimals":e=n(a,0);break;case"amount_with_comma_separator":e=n(a,2,".",",");break;case"amount_no_decimals_with_comma_separator":e=n(a,0,".",",")}return o.replace(t,e)};

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button.drawer__close').forEach(button => button.addEventListener('click', this.closeMenuDrawer.bind(this)));
    this.querySelectorAll('button[class*="close"]').forEach(closeButton => closeButton.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;
    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;
    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);

    if(summaryElement && summaryElement.parentNode.classList.contains('cart-drawer-container')) {
      document.getElementById('shopify-section-header').style.zIndex = '10';
    }
  }

  closeMenuDrawer(event, elementToFocus = false) {
    console.log('closeMenuDrawer()');
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });

    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
    if(this.mainDetailsToggle.classList.contains('cart-drawer-container')) {
      document.getElementById('shopify-section-header').style.zIndex = '3';
    }
    setTimeout(() => {
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      console.log(`overflow-hidden-${this.dataset.breakpoint}`);
    },100);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    console.log('openMenuDrawer()');
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    },200);

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.getElementById('shopify-section-header').style.zIndex = '10';
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.getElementById('shopify-section-header').style.zIndex = '3';
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();

  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class QuickAdd extends HTMLElement {
  constructor() {
    super();
    this.json = JSON.parse(this.closest('.card').getAttribute('data-json'));
    this.querySelectorAll('input').forEach((input) => {
      input.addEventListener('change', this.addItem.bind(this));
    });

  }
  addItem(event) {
    console.log('QuickAdd addItem()');
    const checked = Array.from(this.querySelectorAll('input[type="radio"]:checked'), e => e.value).join(' / ');
    this.json.forEach(variant => {
      if(variant.title != checked) return true;
      const quickAddObj = {
        items: [
          {
            id: variant.id,
            quantity: 1
          }
        ]
      }
      addToCart(quickAddObj);
    });
  }
}
customElements.define('quick-add', QuickAdd);

class CardSwatches extends HTMLElement {
  constructor() {
    super();
    this.json = JSON.parse(this.closest('.card').getAttribute('data-json')) || false;
    console.log('Parsed JSON from closest .card:', this.json);
    this.data = false;
    this.isFeaturedCarousel = this.closest('.featured-carousel__item') || false;
    this.maxColors = this.isFeaturedCarousel ? 5 : 10;
  }
  findColors() {
    console.log('findColors started', this.json);
    fetch(`/search?q=${this.json[0].productStyle}&type=product&view=api`)
    .then(response => response.json())
    .then(data => {
      if(data.length <= 1) return;
      const filteredData = data.filter(item => item.title === this.json[0].productStyle);
      console.log('Filtered data:', filteredData); // This will log the data that passed the filter
      this.data = filteredData;
      this.buildSwatches();
    })
    .catch(error => console.log('Error in findColors', error))
    .finally(() => {
      console.log('findColors completed', this.data); // This will log the data after assignment to this.data
    });
  }
  buildSwatches() {
    console.log('buildSwatches started', this.data);
    let totalFound = 0;
    if(this.classList.contains('swatches-loaded')) 
    return;
    for(const item of this.data) {
      console.log(`Processing item ${totalFound + 1}:`, item.title);
      console.log('Options:', item.options);
      console.log('Variants:', item.variants.map(variant => variant.options));
      const itemTitle = item.title.replace("'",'');
      if(item.title.indexOf('Extended') > -1) return true;
      if(itemTitle !== this.json[0].productStyle) return true;
      if(item.type !== this.json[0].type) return true;
      const colorIndex = item.options.indexOf('Color');
      const colorValue = item.variants[0].options[colorIndex];
      console.log('Color Index:', colorIndex, 'Color Value:', colorValue);
      const swatch = document.createElement('button');
      swatch.classList.add('card-swatch__button');
      swatch.setAttribute('data-color',colorValue);
      swatch.setAttribute('data-tooltip',colorValue);
      if(colorValue == this.json[0].color) {
        swatch.classList.add('active');
      }
      swatch.setAttribute('data-product',`/products/${item.handle}?view=card`);
      this.appendChild(swatch);
      swatch.addEventListener('click', this.updateContent.bind(this));
      totalFound++;
      if(totalFound === 1) {
        this.classList.add('swatches-loaded');
      }
      if(totalFound >= this.maxColors) {
        this.addPlus(item.handle);
        return false;
      }
    };

  }
  addPlus(handle) {
    const plusButton = document.createElement('a');
    plusButton.setAttribute('href',`/products/${handle}`);
    plusButton.classList.add('other-colors__all-link');
    plusButton.innerHTML = '&plus;';
    this.appendChild(plusButton);
  }
  updateContent(event) {
    const elementsToUpdate = [
      '.card__media',
      '.quick-add__wrapper',
      '.card__main-content',
      '.card__badge'
    ];
    const myCard = event.target.closest('.product-card');
    fetch(event.target.getAttribute('data-product'))
    .then(response => response.text())
    .then(data => {
      var parser = new DOMParser();
      var doc = parser.parseFromString(data,'text/html');
      elementsToUpdate.forEach(el => {
        const currentEl = myCard.querySelector(el);
        const newEl = doc.querySelector(el);
        if(currentEl && newEl) {
          currentEl.innerHTML = newEl.innerHTML;
        } else {
          console.log(currentEl,newEl,el);
        }
        lazyImages();
      });
      myCard.querySelectorAll('.card-swatch__button').forEach(button => {
        button.classList.remove('active');
      });
      event.target.classList.add('active');
      const newJson = doc.querySelector('.product-card').getAttribute('data-json');
      myCard.setAttribute('data-json',newJson);
      myCard.querySelector('quick-add').json = JSON.parse(newJson);

    })
    .catch(error => console.log(error));
  }
}
customElements.define('card-swatches', CardSwatches);


const playPauseVideo = () => {
  let videos = document.querySelectorAll("video");
  videos.forEach((video) => {
    // We can only control playback without insteraction if video is mute
    video.muted = true;
    // Play is a promise so we need to check we have it
    let playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.then((_) => {
        let observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.intersectionRatio <= 0 && !video.paused) {
                video.pause();
                console.log('pause me');
              } else if (video.paused) {
                video.play();
              }
            });
          }
        );
        observer.observe(video);
      });
    }
  });
}

// And you would kick this off where appropriate with:
playPauseVideo();


const lazyImages = () => {
  const targets = document.querySelectorAll(".media img");
  const lazyLoad = target => {
    if(target.classList.contains('fade')) return true;
    const io = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          const src = img.getAttribute('data-src');
          img.setAttribute('src', src);
          img.classList.add('fade');
          observer.disconnect();
        }
      });
    }, {
      threshold: 0.33
    });
    io.observe(target)
  };
  targets.forEach(lazyLoad);
};
lazyImages();


const totalColors = () => {
  const targets = document.querySelectorAll(".total-colors");
  const getTotalColors = target => {
    if(target.classList.contains('colors-found')) return;
    const io = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          observer.disconnect();
          const cardStyle = entry.target.getAttribute('data-style');
          const cardColor = entry.target.getAttribute('data-color');
          const cardType = entry.target.getAttribute('data-type');
          let totalFound = 0;
          fetch(`/search?q=${cardStyle}&type=product&view=api`)
          .then(response => response.json())
          .then(data => {
            if(data.length <= 1) return;
            data.forEach(item => {
              const style = item.title.split(' - ')[0];
              if(item.type !== cardType) return true;
              if(style !== cardStyle) return true;
              totalFound++;
            });

            if(totalFound > 1) {
              const allMatches = document.querySelectorAll(`.total-colors[data-style="${cardStyle}"]`);
              allMatches.forEach(match => {
                match.innerHTML = `+ ${totalFound} Colors`;
                match.classList.add('colors-found');
              });
            }
          })
          .catch(error => console.log(error));

        }
      });
    }, {
      threshold: 0.5
    });
    io.observe(target);
  };
  targets.forEach(getTotalColors);
};
totalColors();






const productCardHovers = () => {
  const productCards = document.querySelectorAll('.product-card');
  productCards.forEach(card => {
    const cardSwatches = card.querySelector('card-swatches');
    card.addEventListener('mouseenter', event => {
      if(cardSwatches.classList.contains('swatches-loaded')) return;
      cardSwatches.findColors();
    });
  });
};

productCardHovers();

const addToCart = (itemsObj) => {
  if(!itemsObj.hasOwnProperty('sections')) {
    itemsObj.sections = "cart-drawer,cart-icon-bubble,main-cart-items";
  }
  if(!itemsObj.hasOwnProperty('sections_url')) {
    itemsObj.sections_url = "/cart?sections=cart-drawer,cart-icon-bubble,main-cart-items";
  }
  fetch('/cart/add.js', {
    body: JSON.stringify(itemsObj),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
    },
    method: 'POST'
  }).then(function(response) {
    return response.json();
  }).then(function(json) {
    /* we have JSON */
    if(json.status == 422 && json.message == "Cart Error") {
      itemsObj.items.shift();
      addToCart(itemsObj);
    } else {
      cartUpdate(json);
    }
    const cartDrawerSummary = document.querySelector('cart-drawer .header__icon');
    if(!cartDrawerSummary.parentNode.hasAttribute('open')) {
      cartDrawerSummary.click();
    }

    document.dispatchEvent(new CustomEvent("addtocart"));
  }).catch(function(err) {
    /* uh oh, we have error. */
    console.log(err)
  });
};

const cartUpdate = (json = false) => {

  const cartUpdates = [
    {
      section: "cart-drawer",
      elements: [".drawer__content","#cart-icon-bubble",'.drawer__final']
    },
    {
      section: "cart-icon-bubble",
      elements: [".cart-icon-bubble-wrapper"]
    }
  ];

  const mainCart = document.querySelector('#main-cart-items');
  if(mainCart) {
    cartUpdates.push({
      section: "main-cart-items",
      elements: ['.cart-items','.totals__subtotal-value','.cart-sidebar .affirm-amount']
    });
    window.location.href= '/cart';
  }


  cartUpdates.forEach(update => {
    update.elements.forEach(element => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(json.sections[update.section], "text/html");
      const elOld = document.querySelector(element);
      const elNew = doc.querySelector(element);
      if(elOld && elNew) {
        elOld.innerHTML = elNew.innerHTML;
      } else {
        console.log(elOld, elNew, element);
      }
    });
  });

  document.querySelectorAll('.loading-overlay').forEach(loader => {
    loader.classList.add('hidden');
  });

  const productAddButton = document.querySelector('.product-form__submit');
  if(productAddButton) {
    productAddButton.classList.remove('loading');
    productAddButton.removeAttribute('aria-disabled');
    productAddButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
  }

  const pdpBuy2Get1 = document.querySelector('.product .buy-2-get-1');
  if(pdpBuy2Get1 && window.location.href.indexOf('/products/')) {
    fetch(window.location.href)
    .then(response => response.text())
    .then(html => {
      const p = new DOMParser();
      const d = p.parseFromString(html, "text/html");
      pdpBuy2Get1.innerHTML = d.querySelector('.product .buy-2-get-1').innerHTML;
    });
  }

}

const klaviyoForms = () => {
  const subscribeForms = document.querySelectorAll(".klaviyo-subscribe");
  subscribeForms.forEach((form) => {
    const button = form.querySelector(".newsletter-form__button");
    button.addEventListener("click", function (e) {
      e.preventDefault();
	  klaviyoSubscribe(form);
    });
  });
  const bisForms = document.querySelectorAll(".klaviyo-bis");
  bisForms.forEach((form) => {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      theme.klaviyoSubscribe(form,function() {
        klaviyoBISsubmit(form);
      });
    });
  });
};

klaviyoForms();

const klaviyoSubscribe = (form, callback) => {

  const email = form.querySelector('input[name="email"]').value;
  const phone = form.querySelector('input[name="phone"]');
  const acceptsMarketing =  true;
  const listId = form.querySelector('input[name="g"]').value;
  const successMessage = form.getAttribute("data-success-message");
  const messages = form.querySelector(".messages");
  const subscribeUrl = "//manage.kmail-lists.com/ajax/subscriptions/subscribe";
  let phoneNumber = '';


  if (email === "") {
    messages.textContent = "Please enter a valid email address";
    messages.classList.remove("hidden");
    return false;
  }

  if(phone && phone.value != '') {
    const countryCode = form.querySelector('.iti__selected-flag').getAttribute('title').split(': ')[1];
    phoneNumber = `${countryCode}${phone.value}`;
  }

  const bodyContent = {
    g: listId,
    email: email,
    sms_consent: true,
    $fields: '$phone_number,sms_consent',
    $phone_number: phoneNumber,
    $consent: ['sms'],
  };

  fetch(subscribeUrl, {
    body: new URLSearchParams(bodyContent),
    method: "POST",
  })
  .then((response) => response.json())
  .then((response) => {

    if (response.success) {
      messages.textContent = successMessage;  
    } else {
      messages.textContent = response.errors;
    }
    console.log('subscribe',response);
    messages.classList.remove("hidden");
    if (callback && typeof callback === 'function') {
      callback();
    }
  })
  .catch((err) => {
    console.error(err);
  });
};

const klaviyoBISsubmit = (form) => {
  const url = "//a.klaviyo.com/onsite/components/back-in-stock/subscribe";
  const email = form.querySelector(".klaviyo-bis-email").value;
  const messages = form.querySelector(".messages");
  const hiddenInfo = form.querySelector('.klaviyo-variant-id');
  var variantId = false;
  var productId = false;
  if(hiddenInfo) {
    variantId = parseFloat(hiddenInfo.value);
    productId = hiddenInfo.getAttribute('product-id');
  } else {
    variantId = window.currentVariant.id || false;
    productId = window.currentVariant.productId || false;
  }

  const formBody = new URLSearchParams({
    a: window.klaviyoAccountId,
    email: email,
    variant: variantId,
    product: productId,
    platform: "shopify"
  });
  messages.classList.add("hidden");
  if (email === "") {
    messages.textContent = "Please enter a valid email";
    messages.classList.remove("hidden");
    return false;
  }

  fetch(url, {
    body: formBody,
    method: "POST",
  })
  .then((response) => response.json())
  .then((response) => {
    if (response.success) {
      messages.textContent = "You're in! We'll let you know when it's back.";
    } else {
    }
    messages.classList.remove("hidden");
  })
  .catch((err) => {
    console.error(err);
  });
};


document.addEventListener('shopify:section:load', event => {
  lazyImages();
  playPauseVideo();
  productCardHovers();
  klaviyoForms();
});


document.addEventListener('DOMContentLoaded', function() {
  var mainContent = document.getElementById('GatedSaleContent');
  var placeholder = document.getElementById('GatedContentPlaceholder');
  var messagesDiv = document.querySelector('.messages');
  var background = document.getElementById('MainContent');

  var isCustomerLoggedIn = typeof ShopifyAnalytics !== 'undefined' && typeof ShopifyAnalytics.meta !== 'undefined' && ShopifyAnalytics.meta.page.customerId;
  console.log('Customer logged in:', isCustomerLoggedIn);

  var formSubmitted = localStorage.getItem('formSubmitted');
  console.log('Form submitted:', formSubmitted);

  if (formSubmitted || isCustomerLoggedIn) {
    if (placeholder) {
      placeholder.style.display = 'none';
    }
    if (mainContent) {
      mainContent.style.display = 'block';
      background.style.backgroundImage = 'none';
      background.style.height = 'auto';
    }
  } else {
    if (placeholder) {
      placeholder.style.display = 'block';
    }
    if (mainContent) {
      mainContent.style.display = 'none';
    }
  }

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && messagesDiv.innerText.trim() !== '') {
        console.log('Changes detected in messages div');
        localStorage.setItem('formSubmitted', 'true');
        console.log('Form submission flag saved to localStorage');

        setTimeout(function() {
          location.reload();
        }, 1000);
      }
    });
  });

  if (messagesDiv) {
    observer.observe(messagesDiv, { childList: true, subtree: true });
  } else {
    console.error('Messages div not found');
  }
});
